<!-- 趣味测评报告 -->
<template>
  <div class="container">
    <img class="pageImg" :class="{'pageImg_wx':platform == 'wx'}" :src="detailData.cardImageUrl" mode="widthFix"/>
    <!-- <img class="pageImg" src="@/assets/images/home/pageBg.png" alt="" /> -->
    <div class="result_type_box" :class="{'result_type_box_app':platform == 'app'}"  :style="{ transform: platform == 'app'?'0px':`translateY(${0}px)` }">
      <div class="result_type_top">
        <img
          class="result_icon"
          src="@/assets/images/report/right_icon.png"
          alt=""
        />
        <div class="result_type">{{ detailData.cardCategoryOne }}</div>
      </div>
      <div class="result_type_bottom">
        <div class="result_subtitle">
          {{ detailData.cardCategoryTwo }}
        </div>
        <img
          class="left_icon"
          src="@/assets/images/report/left_icon.png"
          alt=""
        />
      </div>
    </div>
    <div
      class="funReport"
      :style="{
        paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
      }"
    >
      <div class="navigator" :style="{background: `url(${detailData.cardImageUrl})`}">
        <div class="back_share" v-if="platform == 'app'" :style="{
        paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
      }">
          <img
            class="back_img"
            src="@/assets/images/home/back@2x.png"
            @click="back()"
            @touchmove.stop.prevent
            alt
          />
          <div>测评报告</div>
          <img
            @click="shareHandle"
            class="share_img"
            src="@/assets/images/home/share.png"
            alt
          />
        </div>
        <div class="test_info">
          <div class="test_img_bg">
            <img
              class="test_img"
              src="@/assets/images/home/test_icon.png"
              alt=""
            />
          </div>
          <div class="test_info_content">
            <div class="test_name">{{ detailData.assessmentTitle }}</div>
            <div class="test_time">
              测评时间：
              {{ detailData.generateTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="pageContent" ref="pageContent">
        <div class="blank_box" ref="BBRef"></div>
        <!-- 基础信息 -->
        <div class="content">
          <!-- 专属标签 -->
          <div
            v-if="detailData.labels.length > 0"
            class="tags_box"
            :style="{
              background: `url(${tagsBg})`,
              'background-repeat': 'no-repeat',
              'background-size': '100% 100%',
            }"
          >
            <div class="tags_title">你的专属标签</div>
            <div class="tags_list">
              <div
                class="tags_item"
                v-for="(item, index) in detailData.labels"
                :key="index"
              >
                <div
                  class="tags_text"
                  :style="{
                    '--tag-color': item.color,
                  }"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="content_box">
            <!-- 解析概览 -->
            <div class="module_box">
              <div
                class="content_title_box"
                :style="{
                  background: `url(${analyzeBg})`,
                  'background-repeat': 'no-repeat',
                  'background-size': '100% 100%',
                }"
              >
                <div
                  class="content_title"
                  :style="{
                    background: `url(${analyzeTitleBg})`,
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                  }"
                >
                  解析概览
                </div>
              </div>
              <div class="module_content">
                <div class="content_description">
                  {{ detailData.overview }}
                </div>
                <!-- 图表 -->
                <div
                  class="chartContent"
                  v-if="detailData.chartType == 'GAUGE'"
                >
                  <!-- 仪表盘 -->
                  <!--  -->
                  <div
                    class="demi_chartContent"
                    v-if="
                      detailData.chartDataType === 'SUM_SCORE' ||
                        detailData.chartDataType === 'SUM_SCORE_PERCENT_SIGN' ||
                        detailData.chartDataType === 'SUM_SCORE_PERCENT'
                    "
                  >
                    <div id="GAUGE" style="width: 250px; height: 250px"></div>
                    <div class="demi_title">{{ detailData.chartTitle }}</div>
                  </div>
                  <template v-else>
                    <div
                      v-for="(dimension, dIdx) in detailData.data.dimensionData"
                      :key="dIdx"
                    >
                      <div
                        :id="'GAUGE' + dIdx"
                        style="width: 168px; height: 168px"
                      ></div>
                      <div class="demi_title" style="width: 168px;">
                        {{ dimension.title }}
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 水波图 -->
                <div
                  class="chartContent"
                  v-if="detailData.chartType == 'WATERWAVE'"
                >
                  <div
                    class="demi_chartContent"
                    v-if="
                      detailData.chartDataType === 'SUM_SCORE_PERCENT_SIGN' ||
                        detailData.chartDataType === 'SUM_SCORE_PERCENT'
                    "
                  >
                    <div
                      id="WATERWAVE"
                      style="width: 250px; height: 250px;"
                    ></div>
                    <div class="demi_title">{{ detailData.chartTitle }}</div>
                  </div>
                  <template v-else>
                    <div
                      v-for="(dimension, dIdx) in detailData.data.dimensionData"
                      :key="dIdx"
                    >
                      <div
                        :id="'WATERWAVE' + dIdx"
                        style="width: 168px; height: 168px"
                      ></div>
                      <div class="demi_title" style="width: 168px;">
                        {{ dimension.title }}
                      </div>
                    </div>
                  </template>
                </div>
                <!-- 雷达图 -->
                <div
                  class="chartContent"
                  v-if="detailData.chartType == 'RADAR'"
                >
                  <div id="RADAR" style="width: 100%; height: 281px;"></div>
                </div>
                <!-- 条形图 -->
                <div class="chartContent" v-if="detailData.chartType == 'BAR'">
                  <div style="width: 100%; height: 20px;"></div>
                  <div
                    class="bar_item"
                    v-for="(dimension, dIdx) in detailData.data.dimensionData"
                    :key="dIdx"
                  >
                    <template v-if="dIdx % 2 === 0">
                      <div class="bar_item_label">
                        {{ dimension.dimension || "暂无" }}
                      </div>
                      <div class="bar_item_content">
                        <div
                          v-if="
                            detailData.chartDataType ===
                              'DIMENSION_SCORE_PERCENT' ||
                              detailData.chartDataType ===
                                'SUM_SCORE_PERCENT' ||
                              detailData.chartDataType ===
                                'SUM_SCORE_PERCENT_SIGN' ||
                              detailData.chartDataType ===
                                'DIMENSION_SCORE_PERCENT_SIGN'
                          "
                          class="bar_item_inner"
                          :style="{ width: dimension.scorePercentage + '%' }"
                        ></div>
                        <div
                          v-else
                          class="bar_item_inner"
                          :style="{ width: dimension.score + '%' }"
                        ></div>
                      </div>
                    </template>
                    <template v-if="dIdx % 2 === 1">
                      <div class="bar_item_content">
                        <div
                          v-if="
                            detailData.chartDataType ===
                              'DIMENSION_SCORE_PERCENT' ||
                              detailData.chartDataType ===
                                'SUM_SCORE_PERCENT' ||
                              detailData.chartDataType ===
                                'SUM_SCORE_PERCENT_SIGN' ||
                              detailData.chartDataType ===
                                'DIMENSION_SCORE_PERCENT_SIGN'
                          "
                          class="bar_item_inner"
                          :style="{ width: dimension.scorePercentage + '%' }"
                        ></div>
                        <div
                          v-else
                          class="bar_item_inner"
                          :style="{ width: dimension.score + '%' }"
                        ></div>
                      </div>
                      <div class="bar_item_label">
                        {{ dimension.dimension || "暂无" }}
                      </div>
                    </template>
                  </div>
                </div>
                <div class="charts_desc" v-html="px2vwHtml(detailData.chartDesc)">
                </div>
              </div>
              <div class="module_list">
                <div
                  class="module_item"
                  v-for="(item, index) in detailData.angles"
                  :key="index"
                >
                  <div class="item_title_box">
                    <div class="title_line"></div>
                    <div class="module_item_title">
                      {{ item.textTitle }}
                    </div>
                  </div>
                  <div v-if="item.type == 'IMAGE'" class="image_block">
                    <div
                      class="module_item_img_content"
                      v-for="(child, index) in item.images"
                      :key="index"
                    >
                      <div class="module_item_img_box">
                        <img
                          class="module_item_img"
                          :src="child.imageUrl"
                          alt=""
                        />
                      </div>
                      <div class="module_item_img_name">
                        {{ child.imageName }}
                      </div>
                    </div>
                  </div>
                  <div v-if="item.type == 'TEXT'" class="module_item_text_box">
                    <div
                      class="module_item_text"
                      v-html="px2vwHtml(item.textContent)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 详情解读 -->
            <div class="module_box">
              <div
              v-if="hasValidDescription"
                class="content_title_box"
                :style="{
                  background: `url(${analyzeBg})`,
                  'background-repeat': 'no-repeat',
                  'background-size': '100% 100%',
                }"
              >
                <div
                  class="content_title"
                  :style="{
                    background: `url(${analyzeTitleBg})`,
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                  }"
                >
                  详情解读
                </div>
              </div>
              <div class="module_list">
                <!-- 图表 -->
                <div
                  class="chartContent"
                  v-if="detailData.dimensionDetail.chartType == 'GAUGE'"
                >
                  <!-- 仪表盘 -->

                  <div
                    class="module_center"
                    v-for="(dimension, dIdx) in detailData.dimensionDetail
                      .dimensionData"
                    :key="dIdx"
                  >
                    <div
                      :id="'GAUGE_D' + dIdx"
                      style="width: 168px; height: 168px"
                    ></div>
                    <div class="demi_title" style="width: 168px;">
                      {{ dimension.title }}
                    </div>
                    <div
                      class="rich_style"
                      v-html="px2vwHtml(
                        detailData.dimensionDetail.dimensionSegments[dIdx]
                          .description)
                      "
                    ></div>
                  </div>
                </div>
                <!-- 水波图 -->
                <div
                  class="chartContent"
                  v-if="detailData.dimensionDetail.chartType == 'WATERWAVE'"
                >
                  <div
                    class="module_center"
                    v-for="(dimension, dIdx) in detailData.dimensionDetail
                      .dimensionData"
                    :key="dIdx"
                  >
                    <div
                      :id="'WATERWAVE_D' + dIdx"
                      style="width: 168px; height: 168px"
                    ></div>
                    <div class="demi_title" style="width: 168px;">
                      {{ dimension.title }}
                    </div>
                    <div
                      class="rich_style"
                      v-html="px2vwHtml(
                        detailData.dimensionDetail.dimensionSegments[dIdx]
                          .description)
                      "
                    ></div>
                  </div>
                </div>
                <!-- 雷达图 -->
                <div
                  class="chartContent"
                  v-if="detailData.dimensionDetail.chartType == 'RADAR'"
                >
                  <div id="RADAR_D" style="width: 100%; height: 281px;"></div>
                  <div
                    v-for="(dimension, dIdx) in detailData.dimensionDetail
                      .dimensionSegments"
                    :key="dIdx"
                  >
                    <!-- <div class="demi_title" style="width: 168px;">
                      {{ dimension.title }}
                    </div> -->
                    <template v-if="dimension.description">
                    <div class="item_title_box">
                      <div class="title_line"></div>
                      <div class="module_item_title">
                        {{ dimension.dimension }}
                      </div>
                    </div>
                    <div
                      class="rich_style"
                      v-html="px2vwHtml(dimension.description)"
                    ></div>
                    </template>
                  </div>
                </div>
                <!-- 条形图 -->
                <div
                  class="chartContent"
                  v-if="detailData.dimensionDetail.chartType == 'BAR'"
                >
                  <div style="width: 100%; height: 20px;"></div>
                  <div
                    class="bar_item"
                    v-for="(dimension, dIdx) in detailData.dimensionDetail
                      .dimensionData"
                    :key="dIdx"
                  >
                    <template v-if="dIdx % 2 === 0">
                      <div class="bar_item_label">
                        {{ dimension.dimension || "暂无" }}
                      </div>
                      <div class="bar_item_content">
                        <div
                          v-if="
                            detailData.dimensionDetail.chartDataType ===
                              'PERCENT_SIGN' ||
                              detailData.dimensionDetail.chartDataType ===
                                'PERCENT'
                          "
                          class="bar_item_inner"
                          :style="{ width: dimension.scorePercentage + '%' }"
                        ></div>
                        <div
                          v-else
                          class="bar_item_inner"
                          :style="{ width: dimension.score + '%' }"
                        ></div>
                      </div>
                    </template>
                    <template v-if="dIdx % 2 === 1">
                      <div class="bar_item_content">
                        <div
                          v-if="
                            detailData.dimensionDetail.chartDataType ===
                              'PERCENT_SIGN' ||
                              detailData.dimensionDetail.chartDataType ===
                                'PERCENT'
                          "
                          class="bar_item_inner"
                          :style="{ width: dimension.scorePercentage + '%' }"
                        ></div>
                        <div
                          v-else
                          class="bar_item_inner"
                          :style="{ width: dimension.score + '%' }"
                        ></div>
                      </div>
                      <div class="bar_item_label">
                        {{ dimension.dimension || "暂无" }}
                      </div>
                    </template>
                  </div>
                </div>
                <div class="module_content">
                  <div
                    v-for="(dimension, dIdx) in detailData.dimensionDetail
                      .dimensionSegments"
                    :key="dIdx"
                  >
                    <!-- <div class="demi_title " style="width: 168px;">
                      {{ dimension.title }}
                    </div> -->
                    <template v-if="dimension.description">
                    <div class="rich_title_box">
                      <div class="title_line"></div>
                      <div class="module_item_title">
                        {{ dimension.dimension }}
                      </div>
                    </div>
                    <div
                      class="rich_style"
                      v-html="px2vwHtml(dimension.description)"
                    ></div>
                    </template>
                  </div>
                </div>
                <!-- 解释说明 -->
                <div class="charts_desc" v-html="px2vwHtml(detailData.dimensionDetail.chartDesc)">
                </div>
                <!-- 总结 -->
                <div class="content_conclusion2" v-if="detailData.summary">
                  <div class="content_conclusion_bg">
                    <div class="content_conclusion_text1">
                      {{ detailData.summary }}
                    </div>
                  </div>
                  <div class="content_conclusion_text2">
                    {{ detailData.summary }}
                  </div>
                </div>
                <!-- 去聊聊 -->
                <div
                  class="liao_box"
                  :style="{
                    background: `url(${liaoBg})`,
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                  }"
                  @click="toTalk"
                >
                  <div class="liao_text">
                    <div class="liao_text_title">
                      想要进一步探讨你的{{ detailData.cardCategoryTwo }}人格，
                    </div>
                    <div class="liao_text_title">
                      获取更个性的建议和支持吗？
                    </div>
                  </div>
                  <!-- <div class="liao_text_btn">
                    来找朏朏聊聊吧！
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 是否推荐 -->
          <div
            class="recommend_yes_no"
            :style="{
              background: `url(${recommendBg})`,
              'background-repeat': 'no-repeat',
              'background-size': '100% 100%',
            }"
          >
            <div class="recommend_title">您觉得这个测评怎么样？</div>
            <div class="recommend_btn">
              <div class="btn_item" @click="isRecommend(true)">
                <div class="btn_item_text">推荐</div>
                <img
                  v-if="detailData.isRecommend === true"
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_yes_active.png"
                  alt=""
                />
                <img
                  v-else
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_yes.png"
                  alt=""
                />
              </div>
              <div class="btn_item" @click="isRecommend(false)">
                <div class="btn_item_text">不推荐</div>
                <img
                  v-if="detailData.isRecommend === false"
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_no_active.png"
                  alt=""
                /><img
                  v-else
                  class="btn_item_img"
                  src="@/assets/images/report/recommend_no.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- 相关推荐 -->
          <div class="recommend" v-if="recommendList.length > 0">
          <img
            class="recommend_img"
            src="@/assets/images/home/popular.png"
            alt=""
          />
          <div class="recommend_box">
            <div
              class="recommend_item"
              v-for="(item, index) in recommendList"
              :key="index"
              @click="reduceUrl(item)"
            >
              <img class="recommend_item_img" :src="item.imageUrl" alt="" />
              <div class="recommend_item_content">
                <div class="recommend_item_title">{{ item.title }}</div>
                <div class="recommend_item_subTitle">{{ item.subtitle }}</div>
                <div class="recommend_item_person_price">
                  <div class="recommend_item_personNum">
                    <img
                      class="recommend_item_personNum_icon"
                      src="@/assets/images/home/person_icon.png"
                      alt=""
                    />
                    <span class="recommend_item_personNum_text"
                      >{{ item.assessTimes }}人测过</span
                    >
                  </div>
                  <div class="recommend_item_price">
                    <span class="recommend_free_text">免费</span
                    >

                    <span
                      v-if="item.paid"
                      :class="
                        item.paid
                          ? 'recommend_item_price_free'
                          : 'recommend_item_price_normal'
                      "
                      >￥{{ item.price }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-liquidfill/src/liquidFill.js";
import { getDetail, recommendation, getReportRecommend } from "@/api/report";
import { Toast } from "vant";
import { px2vw ,px2vwHtml} from "@/utils/mUtils";
import { setStore, getStore } from "@/utils/mUtils";

export default {
  name: "ReportFun",
  data() {
    // 这里存放数据
    return {
      offsetY:0,
      pageContentScrollTop: 0,
      detailData: {
        dimensionDetail: {},
        labels:[]
      },
      id: "",
      reportId: "",
      type: "",
      title: "",
      bgImg: require("@/assets/images/home/pageBg.png"),
      tagsBg: require("@/assets/images/home/tagsBg.png"),
      analyzeBg: require("@/assets/images/home/analyzeBg.png"),
      analyzeTitleBg: require("@/assets/images/home/analyzeTitleBg.png"),
      recommendList: [],
      liaoBg: require("@/assets/images/report/lliaoliao_bg.png"),
      textBg: require("@/assets/images/report/text_bg.png"),
      recommendBg: require("@/assets/images/report/recommend_bg.png"),
    };
  },
  // 监听属性 类似于data概念
  computed: {
    // 判断是否至少有一个 description 不为空字符串
  hasValidDescription() {
    if (!this.detailData.dimensionDetail.dimensionSegments || 
        !Array.isArray(this.detailData.dimensionDetail.dimensionSegments)) {
      return false;
    }
    
    return this.detailData.dimensionDetail.dimensionSegments.some(segment => 
      segment.description && segment.description.trim() !== ''
    );
  },
    // 滚动位置计算属性
    isScrolled() {
      return this.pageContentScrollTop > 0;
    },
    // 判断是否滚动到顶部
    isAtTop() {
      return this.pageContentScrollTop === 0;
    },
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    px2vwHtml,
    // 处理滚动事件
    handlePageContentScroll(event) {
      console.log("---滚动位置", event.target.scrollTop);
      this.pageContentScrollTop = event.target.scrollTop;
    },

    // 滚动到指定位置
    scrollToPosition(position) {
      const pageContent = this.$refs.pageContent;
      if (pageContent) {
        pageContent.scrollTo({
          top: position,
          behavior: "smooth",
        });
      }
    },

    // 滚动到顶部
    scrollToTop() {
      this.scrollToPosition(0);
    },

    // 获取当前滚动位置
    getCurrentScrollPosition() {
      const pageContent = this.$refs.pageContent;
      return pageContent ? pageContent.scrollTop : 0;
    },
    reduceUrl(item) {
      console.log("---相关推荐", item);
      const id = item.id;
      const type = item.category === "FUN" ? 1 : 2;
      this.$router.push({
        path: "/home",
        query: {
          id,
          type,
        },
      });
    },
    shareHandle() {
      const path = encodeURIComponent("Main");
      const params = {
        pageIndex: 0,
      };
      const encodeParams = encodeURIComponent(JSON.stringify(params));
      const url = `${this.$ShareUrl}/share?platform=wx&linkId=usr1jvrml77haac0&path=${path}&params=${encodeParams}`;
      let data = {
        title: this.detailData.assessmentTitle,
        img: this.detailData.cardImageUrlMy,
        url,
      };
      console.log("share - bridge", data);
      this.$bridge.call("share", data);
    },
    back() {
      this.$router.go(-1);
    },
    async getDetailData() {
      const res = await getDetail({ id: this.reportId });
      this.detailData = res.data;
      this.detailData.generateTime = new Date(
        this.detailData.generateTime * 1
      ).format("yyyy-MM-dd hh:mm");
      
      this.$nextTick(() => {
        this.getChartData(res.data.chartType, this.detailData);
        this.getDimensionChartData(
          res.data.dimensionDetail.chartType,
          this.detailData.dimensionDetail
        );
      });
    },
    async getDimensionChartData(name, data) {
      let formatterValue = "";
      let title = "";
      if (
        data.chartDataType == "PERCENT_SIGN" ||
        data.chartDataType == "PERCENT"
      ) {
        // 各维度分数百分比
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (data.chartDataType == "RESULT") {
        // 结果
        formatterValue = "";
      }
      console.log("---formatterValue", formatterValue);

      if (name == "GAUGE") {
        console.log("----看看name是不是GAUGE", name, data);
        // 多个图表渲染
        if (data.dimensionData.length > 0) {
          data.dimensionData.map((d, dIdx) => {
            this.initGauge(
              `${name}_D${dIdx}`,
              data,
              d.dimension,
              d.score,
              d.minScore,
              d.maxScore,
              d.scorePercentage
            );
          });
        }
      } else if (name == "WATERWAVE") {
        console.log("----看看name是不是WATERWAVE", name);
        // 多个图表渲染
        if (data.dimensionData.length > 0) {
          data.dimensionData.map((d, dIdx) => {
            this.initWaterWave(
              `${name}_D${dIdx}`,
              data,
              d.dimension,
              d.score,
              d.minScore,
              d.maxScore,
              d.scorePercentage
            );
          });
        }
      } else if (name == "RADAR") {
        console.log("----看看name是不是RADAR", name, data);
        let chartDom = document.getElementById(`${name}_D`);
        let myChartThree = echarts.init(chartDom);
        let indicatorData = data.dimensionData.map((item) => {
          return {
            name: item.dimension,
            max: item.maxScore,
          };
        });
        let dimensionData = data.dimensionData.map((item) => {
          return item.score;
        });
        console.log(indicatorData, dimensionData);

        let option = {
          series: [
            {
              type: "radar",
              data: [{ value: dimensionData }],
              lineStyle: {
                color: "#A3EDCC",
              },
              itemStyle: {
                color: "#A3EDCC",
              },
              areaStyle: {
                color: "#A3EDCC",
              },
            },
          ],
          radar: {
            radius: "60%",
            indicator: indicatorData,
            center: ["50%", "55%"],
          },
        };
        myChartThree.setOption(option);
      }
    },
    async getChartData(name, data) {
      let formatterValue = "";
      let title = "";
      if (data.chartDataType == "DIMENSION_SCORE") {
        // 各维度分数
        console.log(this.detailData.data);
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (data.chartDataType == "DIMENSION_SCORE_PERCENT_SIGN") {
        // 各维度分数百分比
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (
        data.chartDataType == "DIMENSION_SCORE_PERCENT" ||
        data.chartDataType == "SUM_SCORE_PERCENT"
      ) {
        // 用户各维度得分的百分制分数||用户总得分的百分制分数
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (data.chartDataType == "SUM_SCORE_PERCENT_SIGN") {
        // 总分百分比
        formatterValue =
          data.data.totalScorePercentage +
          (data.chartType == "GAUGE" ? "" : "%");
        console.log("kankan baifenbi", formatterValue);

        title = data.chartTitle || "";
      } else if (data.chartDataType == "RESULT") {
        // 结果
        formatterValue = "";
      } else if (data.chartDataType == "SUM_SCORE") {
        // 总分
        formatterValue = data.data.totalScore;
        title = "总得分";
      }
      console.log("---formatterValue", formatterValue);

      if (name == "GAUGE") {
        console.log("----看看name是不是GAUGE", name, data);
        if (
          data.chartDataType === "SUM_SCORE" ||
          data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
          data.chartDataType === "SUM_SCORE_PERCENT"
        ) {
          this.initGauge(
            name,
            data,
            title,
            formatterValue,
            data.data.minTotalScore,
            data.data.maxTotalScore,
            data.data.totalScorePercentage
          );
        } else {
          // 多个图表渲染
          if (data.data.dimensionData.length > 0) {
            data.data.dimensionData.map((d, dIdx) => {
              this.initGauge(
                `${name}${dIdx}`,
                data,
                d.dimension,
                d.score,
                d.minScore,
                d.maxScore,
                d.scorePercentage
              );
            });
          }
        }
      } else if (name == "WATERWAVE") {
        console.log("----看看name是不是WATERWAVE", name);
        if (
          data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
          data.chartDataType === "SUM_SCORE_PERCENT"
        ) {
          this.initWaterWave(
            name,
            data,
            title,
            formatterValue,
            data.data.minTotalScore,
            data.data.maxTotalScore,
            data.data.totalScorePercentage
          );
        } else {
          // 多个图表渲染
          if (data.data.dimensionData.length > 0) {
            data.data.dimensionData.map((d, dIdx) => {
              this.initWaterWave(
                `${name}${dIdx}`,
                data,
                d.dimension,
                d.score,
                d.minScore,
                d.maxScore,
                d.scorePercentage
              );
            });
          }
        }
      } else if (name == "RADAR") {
        console.log("----看看name是不是RADAR", name, data);
        let chartDom = document.getElementById(name);
        let myChartThree = echarts.init(chartDom);
        let indicatorData = data.data.dimensionData.map((item) => {
          return {
            name: item.dimension,
            max: item.maxScore,
          };
        });
        let dimensionData = data.data.dimensionData.map((item) => {
          return item.score;
        });
        console.log(indicatorData, dimensionData);

        let option = {
          series: [
            {
              type: "radar",
              data: [{ value: dimensionData }],
              lineStyle: {
                color: "#A3EDCC",
              },
              itemStyle: {
                color: "#A3EDCC",
              },
              areaStyle: {
                color: "#A3EDCC",
              },
            },
          ],
          radar: {
            radius: "60%",
            indicator: indicatorData,
            center: ["50%", "55%"],
          },
        };
        myChartThree.setOption(option);
      }
    },
    initGauge(name, data, title, formatterValue, min, max, scorePercentage) {
      console.log("create gauge", name, data, title, formatterValue, min, max);
      let chartDom = document.getElementById(name);
      let myChartOne = echarts.init(chartDom);
      let option = {
        series: [
          {
            min:
              data.chartDataType === "DIMENSION_SCORE_PERCENT" ||
              data.chartDataType === "SUM_SCORE_PERCENT" ||
              data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
              data.chartDataType === "DIMENSION_SCORE_PERCENT_SIGN" ||
              data.chartDataType === "PERCENT" ||
              data.chartDataType === "PERCENT_SIGN"
                ? 0
                : min,
            max:
              data.chartDataType === "DIMENSION_SCORE_PERCENT" ||
              data.chartDataType === "SUM_SCORE_PERCENT" ||
              data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
              data.chartDataType === "DIMENSION_SCORE_PERCENT_SIGN" ||
              data.chartDataType === "PERCENT" ||
              data.chartDataType === "PERCENT_SIGN"
                ? 100
                : max,
            data: [
              // 数据
              {
                value:
                  data.chartDataType === "DIMENSION_SCORE_PERCENT" ||
                  data.chartDataType === "SUM_SCORE_PERCENT" ||
                  data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
                  data.chartDataType === "DIMENSION_SCORE_PERCENT_SIGN" ||
                  data.chartDataType === "PERCENT" ||
                  data.chartDataType === "PERCENT_SIGN"
                    ? scorePercentage
                    : formatterValue,
                name: title || "",
              },
            ],
            title: {
              // 标题
              offsetCenter: ["0%", "120%"],
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
              color: "#000",
              show: false,
            },
            detail: {
              // 详情
              valueAnimation: true,
              color: "#5AD8B7",
              fontStyle: "normal",
              fontWeight: "bold",
              fontFamily: "D-DIN",
              fontSize: 16,
              offsetCenter: [0, "60%"],
              // formatter: "{value}",
              formatter(value) {
                if (
                  data.chartDataType == "SUM_SCORE_PERCENT_SIGN" ||
                  // data.chartDataType == "SUM_SCORE_PERCENT" ||
                  data.chartDataType == "DIMENSION_SCORE_PERCENT_SIGN" ||
                  // || data.chartDataType == "DIMENSION_SCORE_PERCENT"
                  data.chartDataType === "PERCENT_SIGN"
                ) {
                  return value + "%";
                } else {
                  return value;
                }
              },
            },
            type: "gauge",
            radius: "80%",
            splitNumber: 1, //刻度数量
            progress: {
              show: true, //是否显示进度条
              width: 12,
              roundCap: true,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AD8B7", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#79E695", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            pointer: {
              show: true, //是否显示指针
              roundCap: true,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#79E695", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#5AD8B7", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            axisLine: {
              // 轴线
              show: true,
              roundCap: true,
              color: "#A4FDCA", // 设置单一颜色为红色
            },
            axisTick: {
              // 刻度
              show: false,
            },
            splitLine: {
              // 分隔线
              show: false,
            },
            axisLabel: {
              // 刻度标签
              // show: false,
              distance: 1,
              color: "#999",
            },
            anchor: {
              show: false, // 指针中心点
            },
          },
        ],
      };
      myChartOne.setOption(option);
    },
    initWaterWave(
      name,
      data,
      title,
      formatterValue,
      min,
      max,
      scorePercentage
    ) {
      console.log(
        "create water",
        name,
        data,
        title,
        formatterValue,
        min,
        max,
        scorePercentage
      );
      let chartDom = document.getElementById(name);
      let myChartTwo = echarts.init(chartDom);
      let option = {
        series: [
          {
            type: "liquidFill",
            // name: title || "",
            radius: "80%", //显示比例
            center: ["50%", "50%"], //中心点
            amplitude: 5, //水波振幅
            data: [
              // (formatterValue-min) / (max-min),
              // (formatterValue-min) / (max-min),
              // (formatterValue-min) / (max-min),
              (scorePercentage / 100).toFixed(4),
              (scorePercentage / 100).toFixed(4),
              (scorePercentage / 100).toFixed(4),
            ], // data个数代表波浪数
            color: ["#A4FDCA "], //波浪颜色
            backgroundStyle: {
              borderWidth: 6, //外边框
              borderColor: "#A4FDCA ", //边框颜色
              color: "#62DCAE", //边框内部填充部分颜色
            },
            label: {
              //标签设置
              position: ["50%", "50%"],
              // formatter(value) {
              //   return title + "\n\n" + formatterValue;
              // }, //显示文本,
              // formatter: formatterValue,
              formatter(param) {
                // 判断是否为百分制分数
                console.log();

                if (
                  data.chartDataType == "SUM_SCORE_PERCENT_SIGN" ||
                  // data.chartDataType == "SUM_SCORE_PERCENT" ||
                  data.chartDataType == "DIMENSION_SCORE_PERCENT_SIGN" ||
                  // || data.chartDataType == "DIMENSION_SCORE_PERCENT"
                  data.chartDataType === "PERCENT_SIGN"
                ) {
                  return scorePercentage + "%";
                } else {
                  return scorePercentage;
                }
                // return param.seriesName + '\n'
                //     + param.name + '\n'
                //     + 'Value:' + param.value.toFixed(2);
              },
              fontSize: "20px", //文本字号,
              color: "#fff",
            },
            outline: {
              show: false, //最外层边框显示控制
            },
            title: {
              // 标题
              offsetCenter: ["0%", "120%"],
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
              color: "#ff00ff",
              show: true,
            },
          },
        ],
      };
      myChartTwo.setOption(option);
    },
    // 跳转小程序聊聊
    toTalk() {
      console.log("toTalk");

      if (this.platform === "app") {
        this.bridgeRoute({
          path: "Main",
          params: JSON.stringify({ pageIndex: 2 }),
        });
      } else if (this.platform === "wx") {
        this.$wx.miniProgram.navigateTo({ url: `/pages/index/home?index=2` });
      }
    },
    async isRecommend(val) {
      if (
        this.detailData.isRecommend === "" ||
        this.detailData.isRecommend === null
      ) {
        const res = await recommendation({
          id: this.id,
          answerId: this.reportId,
          recommend: val,
        });
        if (res.msg == "success") {
          this.getDetailData();
          Toast("感谢您的反馈~");
        }
      } else {
        Toast("您已反馈过啦~");
      }
    },
    // 获取推荐测评列表
    async getRecommendList() {
      const res = await getReportRecommend({ id: this.id });
      this.recommendList = res.data;
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log("mounted report page");
      if(getStore('transHeight')){
        this.offsetY = getStore('transHeight')
      }
      this.id = this.$route.query.id;
      this.reportId = this.$route.query.reportId;
      this.type = this.$route.query.type;
      this.title = this.$route.query.title;
      this.getDetailData();
      this.getRecommendList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {
    console.log("update report page");

    // 添加滚动事件监听器
    // this.$nextTick(() => {
    //   // setTimeout(() => {
    //   const pageContent = this.$refs.pageContent;
    //   const BBRef = this.$refs.BBRef;
    //     pageContent.scrollTop = BBRef.offsetHeight
    //     console.log("pageContent", pageContent);
    // });
  }, // 生命周期 - 更新之后
  beforeDestroy() {
    // 在组件销毁前移除事件监听器
    // const pageContent = this.$refs.pageContent;
    // if (pageContent) {
    //   pageContent.removeEventListener("scroll", this.handlePageContentScroll);
    // }
  }, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variable.scss";
$ListHeight: calc(100vh - 120px);
.container {
  color: #333333;
  height: 100vh;
  background-color: #f3f4f6;
}
.pageImg {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  &.pageImg_wx{
    transform: translateY(-78px);
  }
}
.result_type_box {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin: 0 auto;
  padding-bottom: 90px;
  padding-bottom: 30px;
  height: 1024px;
  /* margin-bottom: 50px; */
  width: fit-content;
  text-align: center;
  &.result_type_box_app{
    height: 1098px;
  padding-bottom: 30px;

  }
  .result_type_top {
    position: relative;
    display: inline-block;
    padding: 20px 0px 0px 20px;
    .result_icon {
      width: 59px;
      height: 22px;
      position: absolute;
      top: 0;
      right: -24px;
    }
    .result_type {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 33px;
      background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .result_type_bottom {
    position: relative;
    padding: 0px 20px 20px 30px;
    .result_subtitle {
      font-family: Alimama ShuHeiTi;
      font-weight: bold;
      font-size: 49px;
      background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .left_icon {
      width: 53px;
      height: 30px;
      position: absolute;
      left: 0px;
      bottom: 0;
    }
  }
}
.funReport {
  overscroll-behavior: none;
  overflow-y: auto;
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  /* background-color: #f3f4f6; */
  /* padding-bottom: 220px; */

  .navigator {
    width: 100vw;
    /* height: 85px; */
    color: #292929;
    position: fixed;
    top: 0px;
    left: 0;
    z-index: 2;
    .back_share {
      width: 100%;
      padding: 18px 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .back_img {
        width: 21px;
        height: 38px;
      }
      .nav_title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #292929;
        line-height: 72px;
      }
      .share_img {
        width: 38px;
        height: 38px;
      }
    }
    .test_info {
      display: flex;
      align-items: center;
      padding: 18px 36px;
      .test_img_bg {
        width: 70px;
        height: 70px;
        background-color: #ffffff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        .test_img {
          width: 70px;
          height: 70px;
        }
      }
      .test_info_content {
        .test_name {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #292929;
        }
        .test_time {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #292929;
        }
      }
    }
  }
  .pageContent {
    /* overscroll-behavior: none; */
    flex: 1;
    width: 100%;
    /* height: 100vh; */
    /* overflow-y: auto; */
    /* padding-top: 918px; */
    /* padding-top: 50px; */
    /* position: relative; */
    /* top: 200px; */
    left: 0;
    .blank_box {
      height: 1038px;
      /* animation: expandHeight 0.8s ease-out forwards; */
      /* animation: expandHeightSmooth 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards; */
    }

    @keyframes expandHeightSmooth {
      from {
        height: 0;
      }
      to {
        height: 122.4vw;
      }
    }
    .content {
      padding: 0 20px;
      background: linear-gradient(transparent 10%, #f3f4f6 35%, #f3f4f6 100%);

      .result_type_box {
        margin: 0 auto;
        margin-top: 100px;
        margin-bottom: 50px;
        width: fit-content;
        text-align: center;
        .result_type_top {
          position: relative;
          display: inline-block;
          padding: 20px 0px 0px 20px;
          .result_icon {
            width: 59px;
            height: 22px;
            position: absolute;
            top: 0;
            right: -24px;
          }
          .result_type {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 33px;
            background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .result_type_bottom {
          position: relative;
          padding: 0px 20px 20px 30px;
          .result_subtitle {
            font-family: Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 49px;
            background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .left_icon {
            width: 53px;
            height: 30px;
            position: absolute;
            left: 0px;
            bottom: 0;
          }
        }
      }
      .tags_box {
        padding: 30px 40px;
        margin-bottom: 21px;
        border-radius: 30px;
        .tags_title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 36px;
          color: #36b28d;
          margin-left: 8px;
        }
        .tags_list {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          .tags_item {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px 14px;
            height: 47px;
            margin-right: 12px;
            margin-top: 22px;
            background-color: #fff;
            border-radius: 23px;
            .tags_text {
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 26px;
              color: var(--tag-color);
              line-height: 47px;
            }
          }
        }
      }
      .content_box {
        background: #ffffff;
        border-radius: 30px;
        .module_box {
          margin-bottom: 23px;
          .content_title_box {
            padding: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            .content_title {
              width: 307px;
              height: 62px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 32px;
              color: #222222;
            }
          }
          .module_content {
            /* padding: 23px 21px; */
            background-color: #ffffff;
            .content_description {
              margin: 20px;
              padding: 21px 18px 23px 22px;
              background: #f5faf9;
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #282828;
              line-height: 40px;
            }
            .chartContent {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              .demi_chartContent {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              }
            }
          }
          .module_list {
            .chartContent {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
            }
            .module_item {
              .item_title_box {
                display: flex;
                align-items: center;
                padding: 25px 20px 20px 20px;
                .title_line {
                  width: 5px;
                  height: 25px;
                  background: #fade22;
                  border-radius: 2px;
                  margin-right: 15px;
                }
                .module_item_title {
                  font-family: PingFang SC;
                  font-weight: bold;
                  font-size: 28px;
                  color: #222222;
                }
              }
              .image_block {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                padding: 0 18px;
              }
              .module_item_img_content {
                text-align: center;
                width: 330px;
                /* height: 300px; */
                .module_item_img_name {
                  padding: 7px 27px 12px 18px;
                  display: inline-block;
                  background: linear-gradient(90deg, #ffffff 0%, #a4fdca 100%);
                  border-radius: 0px 22px 22px 0px;
                  margin: 16px 0;
                  font-size: 24px;
                }
                .module_item_img_box {
                  /* padding: 0px 20px 0px 20px; */

                  .module_item_img {
                    width: 100%;
                    height: 100%;
                    border-radius: 8px;
                    /* margin-top: 22px;
                    padding-bottom: 22px; */
                    /* border-bottom: 1px dashed #ededed; */
                  }
                }
              }
              /* .module_item_img_content:last-child {
                .module_item_img_box {
                  margin-bottom: 0;
                  .module_item_img {
                    border-bottom: 1px solid #ededed;
                  }
                }
              } */
              .module_item_text_box {
                padding: 0px 20px 20px 20px;
                .module_item_text {
                  padding-bottom: 20px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  font-size: 24px;
                  color: #282828;
                  border-bottom: 1px solid #ededed;
                }
              }
            }
            .content_conclusion2 {
              margin-top: 40px;
              position: relative;
              padding-bottom: 50px;
              .content_conclusion_bg {
                width: calc(100% - 20px);
                margin-left: 20px;
                padding: 14px 0 0 16px;
                background: linear-gradient(90deg, #9ee0c3 0%, #ffffff 46%);
                border-radius: 10px;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #222222;
              }
              .content_conclusion_text1 {
                width: 648px;
                box-sizing: border-box;
                padding: 42px 14px 20px 16px;
                box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
                border-radius: 10px;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                line-height: 40px;
                color: transparent;
              }
              .content_conclusion_text2 {
                width: 648px;
                box-sizing: border-box;
                padding: 42px 14px 37px 16px;
                background: #ffffff;
                box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
                border-radius: 10px;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 26px;
                line-height: 40px;
                color: #222222;
                position: absolute;
                top: 14px;
                left: 36px;
              }
            }
            .module_center {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
          }
          .charts_desc {
            padding: 0 20px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #282828;
            margin-top: 46px;
          }
        }
      }
    }
    .liao_box {
      width: 713px;
      height: 211px;
      padding: 75px 45px 31px 65px;
      .liao_text {
        width: 367px;
        height: 75px;
        text-align: center;
        .liao_text_title {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #222222;
        }
      }
      .liao_text_btn {
        font-family: Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #54c394;
        margin-left: 47px;
      }
    }
    .recommend_yes_no {
      height: 214px;
      padding: 29px 20px;
      margin-top: 23px;
      .recommend_title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 26px;
        color: #222222;
      }
      .recommend_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 67px;
        .btn_item {
          display: flex;
          align-items: center;
          .btn_item_text {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 24px;
            color: #222222;
            margin-right: 39px;
          }
          .btn_item_img {
            width: 40px;
            height: 40px;
          }
        }
        .btn_item:first-child {
          margin-right: 89px;
        }
      }
    }
    .recommend {
      width: 100%;
      margin-top: 25px;
      .recommend_img {
        width: 175px;
        height: 38px;
      }
      .recommend_box {
        margin-top: 20px;
        .recommend_item {
          display: flex;
          align-items: center;
          padding: 15px 20px;
          background: #ffffff;
          border-radius: 22px;
          margin-bottom: 20px;
          .recommend_item_img {
            width: 147px;
            height: 144px;
            margin-right: 18px;
            border-radius: 10px;
          }
          .recommend_item_content {
            width: 100%;
            .recommend_item_title {
              font-family: PingFang SC;
              font-weight: 800;
              font-size: 28px;
              color: #282828;
              line-height: 40px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .recommend_item_subTitle {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #282828;
              line-height: 40px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .recommend_item_person_price {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 20px;
              .recommend_item_personNum {
                display: flex;
                align-items: center;
                .recommend_item_personNum_icon {
                  width: 22px;
                  height: 22px;
                }
                .recommend_item_personNum_text {
                  font-family: PingFang SC;
                  font-weight: 400;
                  font-size: 22px;
                  color: #282828;
                  margin-left: 8px;
                }
              }
            }
            .recommend_item_price {
              .recommend_free_text {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #f36060;
                line-height: 40px;
              }
              .recommend_item_price_free {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #f36060;
                line-height: 40px;
                margin-left: 10px;
                text-decoration: line-through;
              }
              .recommend_item_price_normal {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #f36060;
                line-height: 40px;
              }
            }
          }
        }
      }
    }
  }
}
.demi_title {
  text-align: center;
  font-weight: bold;
}
.bar_item {
  margin: 15px 0;
  display: flex;
  width: 50%;
  height: 30px;
  background-color: #fff;
  .bar_item_label {
    flex: 1;
    font-size: 24px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bar_item_content {
    display: flex;
    align-items: center;
    flex: 1;
    .bar_item_inner {
      /* width: calc(100% - 1px); */
      height: 30px;
      background-color: #64c79b;
    }
    &:nth-child(odd) {
      border-left: 1px solid #ffffff;
      border-right: 1px solid #cccccc;
    }
    &:nth-child(even) {
      border-right: 1px solid #ffffff;
      border-left: 1px solid #cccccc;

      justify-content: flex-end;
    }
  }
}
</style>
